import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import moment from 'moment-business-days';
import { IAlbum, Lightbox } from 'ngx-lightbox';
import { Subject } from 'rxjs';
import { CollectionHelper } from 'src/app/helpers/collection-helper';
import DateHelper from 'src/app/helpers/date-helper';
import ProductHelper from 'src/app/helpers/product-helper';
import Asset from 'src/app/model/asset';
import ProductAsset from 'src/app/model/product-asset';
import IPBoard from 'src/app/model/product/ip-board/ip-board';
import { SoldRented } from 'src/app/model/project/sold-rented';
import { ClientAdjustmentDesignDialogComponent } from 'src/app/pages/client-corner/client-project-detail/client-adjustment-design/client-adjustment-design-dialog/client-adjustment-design-dialog.component';
import { ClientAdjustmentPrintworkDialogComponent } from 'src/app/pages/client-corner/client-project-detail/client-adjustment-printwork/client-adjustment-printwork-dialog/client-adjustment-printwork-dialog.component';
import { IPBoardOnHoldDialogComponent } from 'src/app/pages/projects/client-corner/create-view-base-project/client-base-project-summary/dialog/ip-board-on-hold-dialog/ip-board-on-hold-dialog.component';
import {
  ImmoExecutionInfo,
  ImmoExecutionInfoControllerRequestService,
} from 'src/app/services/api/immo-execution-info/immo-execution-info-controller-request.service';
import { SubProjectControllerRequestService } from 'src/app/services/api/sub-project-controller-request.service';
import {
  ToggleSubProjectApprovalControllerRequestService,
  ToggleSubProjectApprovalResponse,
} from 'src/app/services/api/toggle-sub-project-approval/toggle-sub-project-approval-controller-request.service';
import {
  ModalService,
  ObservableHandlerPair,
} from 'src/app/services/modal.service';
import { ProjectDisplayObservableService } from 'src/app/services/project-display-observable.service';
import { SnackService } from 'src/app/services/snack.service';
import { TabsService } from 'src/app/services/tabs.service';
import BrowserHelper from '../../../helpers/browser-helper';
import { FileHelper } from '../../../helpers/file-helper';
import ProjectHelper from '../../../helpers/project-helper';
import Employee from '../../../model/product/employee';
import { Adjustment } from '../../../model/project/adjustment';
import { Pickup } from '../../../model/project/pickup';
import { Project } from '../../../model/project/project';
import { Repo } from '../../../model/project/repo';
import {
  SUB_PROJECT_TYPES,
  SubProject,
} from '../../../model/project/sub-project';
import { RequestService } from '../../../services/request.service';
import { SubscriptionBasedComponent } from '../../../subscription-helpers/subscription-based.component';
import { EditIPAdjustmentHelper } from './helper/edit-ip-adjustment-helper';
import { PriceLine } from '../../../model/price-line';

@Component({
  selector: 'edit-ip-adjustment',
  templateUrl: './edit-ip-adjustment.component.html',
  styleUrls: [
    './edit-ip-adjustment.component.scss',
    '../../../pages/projects/edit/edit-project.component.scss',
  ],
})
export class EditIPAdjustmentComponent
  extends SubscriptionBasedComponent
  implements OnInit, OnDestroy
{
  init = false;
  @Input()
  project = new Project();
  @Input()
  model = new Adjustment();
  @Input()
  client = false;
  @Input()
  loadSubProject = false;
  @Input()
  collaborative = false;
  @Output()
  public save = new EventEmitter();
  @Output()
  public deleted = new EventEmitter();

  @Output()
  public immediateSave = new EventEmitter();

  numInvolvedCompanies = 1;

  invoiceSent = new Subject<any>();

  subProjectTitle: string;

  isImage = FileHelper.isImage;

  safari: boolean;
  public employeeChoices: Employee[] = [];
  disableDelete = false;

  baseProject: SubProject;
  lowerCaseType: string;
  latestExecutionAssets: ProductAsset[] = [];
  adjustmentExternalAssets: ProductAsset[] = [];
  designAssets: Asset[];
  originalModel: Adjustment;
  executed: boolean = false;
  form: boolean = false;
  minDate: Date;
  projectHasIPBoards: boolean = false;

  showExecutionInfo: boolean = false;
  loadBeforeClose: boolean = false;

  openedFromAppointment: boolean = false;

  soldRented: SoldRented;

  SUB_PROJECT_TYPES = SUB_PROJECT_TYPES;

  divergentPricesOnly = false;
  adjustment: Adjustment | Repo | SoldRented;

  repoByInpress: boolean;

  ipBoard: IPBoard;

  constructor(
    private requestService: RequestService,
    private immoExecutionInfoRequestService: ImmoExecutionInfoControllerRequestService,
    private route: ActivatedRoute,
    private projectDisplayObservableService: ProjectDisplayObservableService,
    private modalService: ModalService,
    private snackService: SnackService,
    private tabsService: TabsService,
    private _lightbox: Lightbox,
    private subProjectControllerService: SubProjectControllerRequestService,
    private toggleSubProjectApprovalControllerRequestService: ToggleSubProjectApprovalControllerRequestService
  ) {
    super();
  }

  ngOnInit() {
    if (!this.client) {
      this.hideActionButtonsIfOpenedFromAppointment();
    }
    const involvedCompanies =
      ProjectHelper.getUniqueCompaniesFromProjectContacts(
        this.project == null ? null : this.project.projectContacts
      );
    if (involvedCompanies != null) {
      this.numInvolvedCompanies = involvedCompanies.length;
    }
    moment.updateLocale('nl-be', {});
    this.minDate =
      DateHelper.getMomentBusinessDayMinProjectPlacement().toDate();
    this.calculateProjectHasIPBoards();
    if (
      this.project != null &&
      this.project.products != null &&
      this.project.products.length > 0 &&
      ProductHelper.isIPBoard(this.project.products[0])
    ) {
      this.ipBoard = this.project.products[0] as IPBoard;
    }
    this.calculateDesignAssets();
    this.calculateLatestExecutionAssets();
    this.executed = ProjectHelper.EXECUTED_FOR_CLIENT_STATUSES.includes(
      this.model.status
    );
    this.lowerCaseType = this.model.type.toLowerCase();
    this.baseProject = this.project.subProjects.find(
      (s) => s.type === 'BaseProject'
    );
    if (
      this.model.projectPlacement &&
      this.model.projectPlacement.projectPlacementAssets
    ) {
      this.adjustmentExternalAssets =
        this.model.projectPlacement.projectPlacementAssets.filter(
          (a) => a.formSection === 'adjustmentExternal'
        );
    }
    this.subProjectTitle = ProjectHelper.getFormDisplayNameUpperCase(
      this.model
    );
    this.subProjectTitle =
      this.subProjectTitle === 'Verkocht/Verhuurd'
        ? 'Sticker VV'
        : this.subProjectTitle;

    this.safari = BrowserHelper.isSafari();

    if (this.client) {
      if (this.model.pickup == null) {
        this.model.pickup = new Pickup();
      }
      this.init = true;
      return;
    }
    if (this.model.id) {
      this.form = false;
      this.initSubProject(this.model);
    } else {
      this.model.withPlacement = true;
      this.form = true;
      this.init = true;
    }
    if (this.invoiceSent != null) {
      this.addSubscription(this.invoiceSent, () => {
        this.disableDelete = true;
      });
    }
    this.addSubscription(
      this.projectDisplayObservableService.getSubProjectDesignVariableChangedSubscribable(),
      () => this.calculateDesignAssets()
    );

    if (this.model.id != null && this.projectHasIPBoards) {
      this.immoExecutionInfoRequestService
        .getImmoExecutionInfo(this.model.id)
        .then((immoExecutionInfo: ImmoExecutionInfo) => {
          this.projectDisplayObservableService
            .getTourConfigurationChangedSubscribable()
            .next({
              subProjectId: this.model.id,
              assignedToTour: immoExecutionInfo.assignedToTour,
              placer: immoExecutionInfo.placer,
              date: immoExecutionInfo.date,
              notExecutedHistoryItem: immoExecutionInfo.notExecutedHistoryItem,
            });
        });
    }

    this.originalModel = { ...this.model };

    this.calculateShowExecutionInfo();
    this.setSoldRented();
  }

  private hideActionButtonsIfOpenedFromAppointment(): void {
    this.addSubscription(
      this.route.fragment,
      (fragment: string) =>
        (this.openedFromAppointment = fragment === 'appointment')
    );
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
    if (this.invoiceSent != null) {
      this.invoiceSent.complete();
      this.invoiceSent = null;
    }
  }

  initSubProject(subproject: SubProject): SubProject {
    this.model = subproject;
    if (this.model.pickup == null) {
      this.model.pickup = new Pickup();
    }
    this.disableDelete =
      this.model.projectInvoices != null &&
      this.model.projectInvoices.some((pi) => pi.teamleaderId != null);
    this.init = true;
    return subproject;
  }

  private calculateDesignAssets(): void {
    let designAssets: Asset[] =
      this.model.projectPlacement == null ||
      !CollectionHelper.isPopulated(
        this.model.projectPlacement.projectPlacementAssets
      )
        ? []
        : this.model.projectPlacement.projectPlacementAssets.map((pa) =>
            pa == null ||
            pa.asset == null ||
            pa.archived ||
            pa.formSection !== 'extraDesign'
              ? null
              : pa.asset
          );
    CollectionHelper.filterInPlace(designAssets, (a) => a != null);

    if (
      designAssets.length === 0 &&
      this.model.type === SUB_PROJECT_TYPES.SOLDRENTED
    ) {
      const soldRented = <SoldRented>this.model;
      if (
        soldRented.signSticker != null &&
        CollectionHelper.isPopulated(soldRented.signSticker.examples)
      ) {
        designAssets = soldRented.signSticker.examples.map((e) =>
          e.archived || e.asset == null ? null : e.asset
        );
        CollectionHelper.filterInPlace(designAssets, (a) => a != null);
      }
    }

    this.designAssets = designAssets;
  }

  private setSoldRented() {
    if (this.model.type === SUB_PROJECT_TYPES.SOLDRENTED) {
      this.soldRented = <SoldRented>this.model;
    }
  }

  openDesignLightbox(): void {
    if (!CollectionHelper.isPopulated(this.designAssets)) {
      return;
    }
    const album: IAlbum[] = this.designAssets.map((a) => {
      return {
        src: '/api/assets/' + a.uuid,
        thumb: '/api/assets/' + a.uuid,
        caption: 'Ontwerp',
      };
    });
    this._lightbox.open(album);
  }

  deleteSubProject() {
    this.modalService.confirmDialog(
      'Actie verwijderen',
      'Bent u zeker dat u deze actie wilt verwijderen?',
      (answer: boolean) => {
        if (answer) {
          this.requestService
            .delete('/subprojects/archive/' + this.model.id)
            .toPromise()
            .then(() => {
              this.model.archived = true;
              this.deleted.emit();
            });
        }
      }
    );
  }

  openOnHoldDialog(): void {
    this.modalService.openComponentInModal(
      IPBoardOnHoldDialogComponent,
      [
        { key: 'project', value: this.project },
        { key: 'subProject', value: this.model },
      ],
      new ObservableHandlerPair(
        (modalRef) => modalRef.componentInstance.close,
        (b: boolean) => {
          if (b) {
            this.projectDisplayObservableService
              .getSubProjectSetOnHoldSubscribable()
              .next(this.model.id);
          }
        }
      ),
      { minWidth: 750 }
    );
  }

  openDesignDialog(): void {
    this.modalService.openComponentInModal(
      ClientAdjustmentDesignDialogComponent,
      [
        { key: 'project', value: this.project },
        { key: 'adjustment', value: this.model },
      ],
      new ObservableHandlerPair(
        (modalRef) => modalRef.componentInstance.close,
        (b: boolean) => {
          if (b) {
            this.projectDisplayObservableService
              .getSubProjectDesignVariableChangedSubscribable()
              .next(this.model.id);

            this.tabsService.closeTab(this.tabsService.getActiveTab(), '/immo');
          }
        }
      )
    );
  }

  openPrintworkDialog(callback?: (b: boolean) => void): void {
    this.modalService.openComponentInModal(
      ClientAdjustmentPrintworkDialogComponent,
      [{ key: 'adjustment', value: this.model }],
      new ObservableHandlerPair(
        (modalRef) => modalRef.componentInstance.getClosedObservable(),
        (b: boolean) => {
          if (callback != null) {
            callback(b);
          }
        }
      ),
      { minWidth: 750 }
    );
  }

  setDesignFinished(): void {
    let error = null;

    if (
      !CollectionHelper.isPopulated(
        this.model.projectPlacement.projectPlacementAssets
      ) ||
      !this.model.projectPlacement.projectPlacementAssets.some(
        (pa) => !pa.archived && pa.formSection === 'extraDesign'
      )
    ) {
      error = 'Er is nog geen ontwerp toegevoegd';
    }
    if (error == null && !this.model.designSentToCustomer) {
      error = 'Ontwerp is nog niet verzonden naar klant';
    }
    if (error == null && !this.model.designApproved) {
      error = 'Ontwerp is nog niet goedgekeurd door klant';
    }

    if (error != null) {
      this.snackService.showError(error);
    } else {
      this.model.designFinished = true;
      this.save.emit(this.model);
    }
  }

  cancel() {
    this.model = this.originalModel;
    this.save.emit(this.originalModel);
  }

  handleApproveWithException(value: boolean): void {
    if (this.shouldShowAquafinWarning()) {
      this.showAquafinWarningModal(value);
    } else {
      this.changeApproved(value);
    }
  }

  private shouldShowAquafinWarning(): boolean {
    return (
      this.isRepoAdjustment() &&
      this.isAquafinCompany() &&
      this.hasInvalidPriceLines()
    );
  }

  private isRepoAdjustment(): boolean {
    return this.adjustment.type === this.SUB_PROJECT_TYPES.REPO;
  }

  private isAquafinCompany(): boolean {
    return (
      this.adjustment.subProjectContact?.company?.regularName === 'Aquafin'
    );
  }

  private hasInvalidPriceLines(): boolean {
    return this.adjustment.projectInvoices.some(this.isInvalidInvoice);
  }

  private isInvalidInvoice(invoice: any): boolean {
    return (
      invoice.priceLines.length === 0 ||
      invoice.priceLines.some(
        //check for any invalid price lines
        (priceline: PriceLine) =>
          priceline.price === '0' || priceline.price === null
      )
    );
  }

  private showAquafinWarningModal(value: boolean): void {
    this.modalService.confirmDialog(
      'Let op',
      'Er is geen extra prijs ingegeven, toch doorgaan?',
      (confirmed) => {
        if (confirmed) {
          this.changeApproved(value);
        }
      }
    );
  }

  changeApproved(value: boolean) {
    if (value) {
      const verificationError = EditIPAdjustmentHelper.verifyApproval(
        this.baseProject
      );
      if (verificationError != null) {
        this.snackService.showError(verificationError);
        return;
      }
      if (
        ProjectHelper.mustHaveAppointment(this.baseProject.projectPlacement) &&
        !(
          this.adjustment.projectPlacement.appointment ||
          this.adjustment.projectPlacement.collectKey
        ) &&
        this.repoByInpress
      ) {
        this.snackService.showError(
          'Er moet een afspraak gemaakt worden voor een plaatsing boven het 2e verdiep.'
        );
        return;
      }
    }
    this.doToggleApproval(value);
  }

  private doToggleApproval(value: boolean): void {
    this.loadBeforeClose = true;

    if (this.model.type === SUB_PROJECT_TYPES.ADJUSTMENT) {
      this.doToggleAdjustmentApproval(value);
    } else {
      this.doCallToggleApproval();
    }
  }

  private doToggleAdjustmentApproval(value: boolean): void {
    if (value) {
      const callback = () => {
        this.doCallToggleApproval();
      };
      this.openPrintworkDialog(callback.bind(this));
    } else {
      this.doCallToggleApproval();
    }
  }

  private doCallToggleApproval(): void {
    this.toggleSubProjectApprovalControllerRequestService
      .toggleSubProjectApproval(this.model.id)
      .then((res: ToggleSubProjectApprovalResponse) => {
        this.model.approved = res.newApprovalValue;
        this.model.approvedRegistration = res.approvedRegistration;
        if (res.newApprovalValue) {
          this.tabsService.closeTab(
            this.tabsService.getActiveTab(),
            null,
            false
          );
        }
      })
      .finally(() => (this.loadBeforeClose = false));
  }

  private calculateProjectHasIPBoards(): void {
    this.projectHasIPBoards =
      CollectionHelper.isPopulated(this.project.products) &&
      this.project.products.some((p) => ProductHelper.isIPBoard(p));
  }

  private calculateLatestExecutionAssets(): void {
    if (this.project == null) {
      return;
    }
    if (CollectionHelper.isPopulated(this.project.subProjects)) {
      const filteredAssets = this.project.subProjects
        .filter(
          (s) =>
            s.type === 'SoldRented' &&
            s.projectPlacement != null &&
            CollectionHelper.isPopulated(
              s.projectPlacement.projectPlacementAssets
            ) &&
            s.projectPlacement.projectPlacementAssets.some(
              (pa: ProductAsset) =>
                !pa.archived && pa.formSection === 'adjustmentPlacementSuccess'
            )
        )
        .map((s) => s.projectPlacement.projectPlacementAssets);
      this.latestExecutionAssets = CollectionHelper.isPopulated(filteredAssets)
        ? filteredAssets[filteredAssets.length - 1].filter(
            (pa: ProductAsset) =>
              !pa.archived && pa.formSection === 'adjustmentPlacementSuccess'
          )
        : [];
    }
    if (
      CollectionHelper.isPopulated(this.project.products) &&
      !CollectionHelper.isPopulated(this.latestExecutionAssets)
    ) {
      this.project.products.forEach((p) => {
        if (!CollectionHelper.isPopulated(p.productAssets)) {
          return;
        }
        p.productAssets.forEach((pa) => {
          if (!pa.archived && pa.formSection === 'execution') {
            this.latestExecutionAssets.push(pa);
          }
        });
      });
    }
  }

  archive(): void {
    this.modalService.confirmDialog(
      'Annuleren/wissen',
      'Bent u zeker dat u deze job wil annuleren? Opgelet: De reeds ingevulde informatie zal verloren gaan.',
      (b) => {
        if (b) {
          this.subProjectControllerService.archive(this.model.id).then(() => {
            this.snackService.showSuccess('Job succesvol verwijderd');
            this.tabsService.closeTab(
              this.tabsService.getActiveTab(),
              '/client-corner',
              false
            );
          });
        }
      }
    );
  }

  calculateShowExecutionInfo() {
    this.showExecutionInfo =
      ProjectHelper.NOT_EXECUTED_STATUSES.includes(this.model.status) ||
      ProjectHelper.getIsExecuted(this.model, this.project);
  }
}
